/**
 * Context resolver for payout monitoring help panel scroll highlight.
 */

const QUEUE_TAB_TO_HELP = {
  open: 'queue-tabs',
  investigating: 'linked-cases',
  smr: 'linked-cases',
  closed: 'queue-tabs',
  all: 'queue-tabs',
}

export function primaryHelpSectionForPayoutMonitoring({
  selectedPayout,
  payoutModalTab,
  queueTab,
  workflowActionsVisible,
}) {
  if (selectedPayout && payoutModalTab === 'attachments') return 'attachments'
  if (selectedPayout && workflowActionsVisible) return 'workflow-actions'
  if (selectedPayout) return 'detail-drawer'
  if (queueTab && QUEUE_TAB_TO_HELP[queueTab]) return QUEUE_TAB_TO_HELP[queueTab]
  return 'overview'
}
